export default __webpack_public_path__ + "static/media/yazar min.c0f70fff.jpg";